function mapOffer(raw) {
    return {
        contractId: raw.contractId ?? "",
        createdEventBlob: raw.createdEventBlob ?? "",
        endInvestor: raw.endInvestor ?? "",
        operator: raw.operator ?? "",
        provider: raw.provider ?? "",
        compliance: raw.compliance ?? "",
        registrar: raw.registrar ?? "",
        clientOnboarder: raw.clientOnboarder ?? "",
        participant: raw.participant ?? "",
    };
}
export function mapPendingActionsResponse(raw) {
    return (raw.offers ?? []).map(mapOffer);
}
export function mapPrepareSubmissionResponse(raw) {
    return {
        unsignedTx: raw.unsignedTx ?? "",
        txHash: raw.txHash ?? "",
    };
}
export function mapGetTransactionResponse(raw) {
    return {
        transactionId: raw.transactionId ?? "",
        status: (raw.status ?? "UNSPECIFIED"),
        effectiveAt: raw.effectiveAt,
        submittingParty: raw.submittingParty,
        completionOffset: raw.completionOffset,
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFwcGluZ3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbWFpbi9tb2R1bGVzL2NhbnRvbi9tYXBwaW5ncy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF1Q0EsU0FBUyxRQUFRLENBQUMsR0FBYTtJQUM3QixPQUFPO1FBQ0wsVUFBVSxFQUFFLEdBQUcsQ0FBQyxVQUFVLElBQUksRUFBRTtRQUNoQyxnQkFBZ0IsRUFBRSxHQUFHLENBQUMsZ0JBQWdCLElBQUksRUFBRTtRQUM1QyxXQUFXLEVBQUUsR0FBRyxDQUFDLFdBQVcsSUFBSSxFQUFFO1FBQ2xDLFFBQVEsRUFBRSxHQUFHLENBQUMsUUFBUSxJQUFJLEVBQUU7UUFDNUIsUUFBUSxFQUFFLEdBQUcsQ0FBQyxRQUFRLElBQUksRUFBRTtRQUM1QixVQUFVLEVBQUUsR0FBRyxDQUFDLFVBQVUsSUFBSSxFQUFFO1FBQ2hDLFNBQVMsRUFBRSxHQUFHLENBQUMsU0FBUyxJQUFJLEVBQUU7UUFDOUIsZUFBZSxFQUFFLEdBQUcsQ0FBQyxlQUFlLElBQUksRUFBRTtRQUMxQyxXQUFXLEVBQUUsR0FBRyxDQUFDLFdBQVcsSUFBSSxFQUFFO0tBQ25DLENBQUM7QUFDSixDQUFDO0FBRUQsTUFBTSxVQUFVLHlCQUF5QixDQUFDLEdBQThCO0lBQ3RFLE9BQU8sQ0FBQyxHQUFHLENBQUMsTUFBTSxJQUFJLEVBQUUsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxRQUFRLENBQUMsQ0FBQztBQUMxQyxDQUFDO0FBRUQsTUFBTSxVQUFVLDRCQUE0QixDQUMxQyxHQUFpQztJQUVqQyxPQUFPO1FBQ0wsVUFBVSxFQUFFLEdBQUcsQ0FBQyxVQUFVLElBQUksRUFBRTtRQUNoQyxNQUFNLEVBQUUsR0FBRyxDQUFDLE1BQU0sSUFBSSxFQUFFO0tBQ3pCLENBQUM7QUFDSixDQUFDO0FBRUQsTUFBTSxVQUFVLHlCQUF5QixDQUFDLEdBQThCO0lBQ3RFLE9BQU87UUFDTCxhQUFhLEVBQUUsR0FBRyxDQUFDLGFBQWEsSUFBSSxFQUFFO1FBQ3RDLE1BQU0sRUFBRSxDQUFDLEdBQUcsQ0FBQyxNQUFNLElBQUksYUFBYSxDQUE0QjtRQUNoRSxXQUFXLEVBQUUsR0FBRyxDQUFDLFdBQVc7UUFDNUIsZUFBZSxFQUFFLEdBQUcsQ0FBQyxlQUFlO1FBQ3BDLGdCQUFnQixFQUFFLEdBQUcsQ0FBQyxnQkFBZ0I7S0FDdkMsQ0FBQztBQUNKLENBQUMifQ==